import Icon from '@mui/icons-material/People';

import { CreateQuestion } from './CreateQuestion';
import { EditQuestion } from './EditQuestion';
import { ListQuestions } from './ListQuestions';

export const QuestionsResourceConfig = {
  create: CreateQuestion,
  edit: EditQuestion,
  list: ListQuestions,
  icon: Icon,
  name: 'questions',
};
